<script setup>
import { useCmsContentStore } from '@/stores'
import { storeToRefs } from 'pinia'
import { ref, onMounted, onBeforeUnmount } from 'vue'

const cmsStore = useCmsContentStore()
const { editModeEnabled } = storeToRefs(cmsStore)

const wrapperRef = ref(null)
const posX = ref(0)
const posY = ref(80)
const dragging = ref(false)
let dragStartX = 0
let dragStartY = 0
let startPosX = 0
let startPosY = 0
let hasMoved = false

function onPointerDown(e) {
  e.preventDefault()
  dragging.value = true
  hasMoved = false
  dragStartX = e.clientX
  dragStartY = e.clientY
  startPosX = posX.value
  startPosY = posY.value

  document.addEventListener('pointermove', onPointerMove)
  document.addEventListener('pointerup', onPointerUp)
}

function onPointerMove(e) {
  e.preventDefault()
  const dx = e.clientX - dragStartX
  const dy = e.clientY - dragStartY

  if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
    hasMoved = true
  }

  const newX = startPosX + dx
  const newY = startPosY + dy
  const maxX = window.innerWidth - 48
  const maxY = window.innerHeight - 48

  posX.value = Math.max(0, Math.min(newX, maxX))
  posY.value = Math.max(0, Math.min(newY, maxY))
}

function onPointerUp() {
  dragging.value = false
  document.removeEventListener('pointermove', onPointerMove)
  document.removeEventListener('pointerup', onPointerUp)
}

function handleClick() {
  if (!hasMoved) {
    cmsStore.toggleEditMode()
  }
}

onMounted(() => {
  posX.value = window.innerWidth - 60
})

onBeforeUnmount(() => {
  document.removeEventListener('pointermove', onPointerMove)
  document.removeEventListener('pointerup', onPointerUp)
})
</script>

<template>
  <div
    ref="wrapperRef"
    class="cms-edit-toggle-wrapper"
    :class="{ 'cms-edit-toggle-wrapper--dragging': dragging }"
    :style="{ top: posY + 'px', left: posX + 'px' }"
    @pointerdown="onPointerDown"
  >
    <VTooltip location="left">
      <template #activator="{ props: tooltipProps }">
        <VBtn
          v-bind="tooltipProps"
          :icon="editModeEnabled ? 'mdi-pencil-off' : 'mdi-pencil'"
          :color="editModeEnabled ? 'warning' : 'primary'"
          size="small"
          elevation="4"
          @click.stop="handleClick"
        />
      </template>
      <span>{{ editModeEnabled ? 'Exit CMS Edit Mode' : 'CMS Edit Mode' }}</span>
    </VTooltip>
  </div>
</template>

<style scoped>
.cms-edit-toggle-wrapper {
  position: fixed;
  z-index: 2501;
  cursor: grab;
  touch-action: none;
  user-select: none;
}

.cms-edit-toggle-wrapper--dragging {
  cursor: grabbing;
}
</style>
